<template>
    <div>

        <main role="main">

            <div class="container-fluid">

              <div class="row">
                <div class="col-md-12">
                  <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
                    <i class="fa fa-chevron-circle-left"></i> {{ $t('text.globals.back') }}
                  </a>
                </div>
              </div>

                <div class="row mt-2 mb-2">
                    <div class="col-md-12">

                        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

                        <div class="row">
                            <div class="col-md-12 mb-5">
                                <b-nav tabs>
                                    <b-nav-item @click="routerGoTo('transactions')" active>{{$t('text.apmPages.transactionsLabel')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('errors')">{{$t('text.apmPages.errors')}}</b-nav-item>
                                    <b-nav-item @click="routerGoTo('metrics')">{{$t('text.apmPages.metrics')}}</b-nav-item>
                                </b-nav>
                            </div>
                        </div>

                        <h3 class="mb-5">
                            {{this.$route.params.serviceName}}
                        </h3>

                        <div class="row mt-3 mb-3">

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="startTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      v-model="startTimestamp"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>

                            <div class="col-md-6">
                                <VueCtkDateTimePicker id="endTime" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                                      formatted="DD.MM.YYYY, HH:mm" v-model="endTimestamp"
                                                      :label="$t('text.apmPages.chooseDate')"
                                                      @input="updateTimes()"
                                                      :locale="$t('text.globals.datePickerLocale')"
                                                      :button-now-translation="$t('text.globals.now')"
                                />
                            </div>
                        </div>


                        <div class="row mt-3" id="wrapper">
                            <div class="col-md-6">
                                <div id="chart-line" class="mt-3">
                                    <label for="transaction-duration">{{$t('text.apmPages.transactionDuration')}}</label>
                                    <apexchart id="transaction-duration" type=line height="300"
                                               :options="transactionDurationChartOptions"
                                               :series="transactionDurationSeries"
                                               :key="transactionDurationDataLoaded"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="chart-line2" class="mt-3">
                                    <label for="requests-per-minute">{{$t('text.apmPages.requestsPerMinute')}}</label>
                                    <apexchart id="requests-per-minute" type=line height="300"
                                               :options="requestsPerMinuteChartOptions"
                                               :series="requestsPerMinuteSeries"
                                               :key="requestsPerMinuteDataLoaded"/>
                                </div>
                            </div>
                        </div>


                        <div>
                            <label for="transaction-groups">{{$t('text.apmPages.transactions.transactionGroups')}}</label>
                            <vue-good-table
                                    id="transaction-groups"
                                    styleClass="vgt-table table table-hover table-striped"
                                    :columns="columns"
                                    :rows="rows">

                                <div slot="emptystate">
                                    <div class="text-center"><i class="fa fa-exclamation-triangle"></i> <em>{{$t('text.globals.noData')}}</em></div>
                                </div>

                                <template slot="table-row" slot-scope="props">

                                    <!-- {{props}} -->

                                     <span v-if="props.column.field == 'finalUser'">

                                            <span v-if="props.row.sample.http.request.headers['Ehramba-Final-User']">
                                            {{props.row.sample.http.request.headers['Ehramba-Final-User'][0]}}
                                            </span>
                                        </span>

                                         <span v-if="props.column.field == 'ip'">

                                            <span v-if="props.row.sample.http.request.headers['X-Real-Ip']">
                                            {{props.row.sample.http.request.headers['X-Real-Ip'][0]}}
                                            </span>
                                        </span>

                                        <span v-if="props.column.field == 'name'">
                                            <a href="javascript:void(0)" class="" @click="onCellClick(props)"><pre class="mb-0" style="color: #007bff">{{props.row.name}}</pre></a>
                                        </span>

                                    <span v-else-if="props.column.field == 'impact'">
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                     :style="{ width: props.row.impact + '%' }"
                                                     :aria-valuenow=props.row.impact*100 aria-valuemin="0"
                                                     :aria-valuemax="100"><!--{{props.row.impact}}--></div>
                                            </div>
                                        </span>


                                    <span v-else>
                                          {{props.formattedRow[props.column.field]}}
                                        </span>

                                </template>
                            </vue-good-table>
                        </div>
                    </div>


                </div>


            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import {VueGoodTable} from 'vue-good-table';
    import axios from 'axios/index';

    library.add(faHome);


    export default {
        name: 'Transactions',
        components: {
            SidebarNavigation
        },
        data() {
            return {
                startTimestamp: null,
                endTimestamp: null,
                startTimeDate: null,
                endTimeDate: null,
                transactionDurationDataLoaded: false,
                requestsPerMinuteDataLoaded: false,
                transactionDurationSeries: [],
                requestsPerMinuteSeries: [],

                transactionDurationChartOptions: {
                    colors: ['#3185fc', '#e6c220', '#f98510'],

                    chart: {
                        group: 'transactionData',
                        id: 'transactionDuration'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return Math.round(value / 1000) + " ms";
                            },
                            minWidth: 0
                        },

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                },
                requestsPerMinuteChartOptions: {
                    colors: ['#00b3a4', '#f98510', '#db1374'],

                    chart: {
                        group: 'transactionData',
                        id: 'requestsPerMinute'
                    },
                    xaxis: {
                        type: "datetime"
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return Math.round(value) + " rpm";
                            },
                            minWidth: 0
                        },

                    },
                    stroke: {
                        width: 3
                    },
                    legend: {
                        position: 'bottom',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                    },
                },
                //table
                columns: [
                    {
                        label:  this.$t('text.apmPages.tableColumns.serviceName'),
                        field: 'name',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.finalUser'),
                        field: 'finalUser',
                        type: 'text',
                        sortable: true,
                        sortFn: this.ehrambaUserSortFn
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.ip'),
                        field: 'ip',
                        type: 'text',
                        sortable: true,
                        sortFn: this.ehrambaIpSortFn
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.avgDuration'),
                        field: 'averageResponseTime',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatMiliseconds,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.p95'),
                        field: 'p95',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatMiliseconds,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.transactionsPerMinute'),
                        field: 'transactionsPerMinute',
                        type: 'text',
                        sortable: true,
                        formatFn: this.formatTransactionsPerMinute,
                    },
                    {
                        label: this.$t('text.apmPages.tableColumns.impact'),
                        field: 'impact',
                        type: 'text',
                        sortable: true,
                    }
                ],
                rows: [],
                breadcrumbItems: [
                    {
                        text: this.$t('text.apmPages.apmLabel'),
                        href: '#/apm'
                    },
                    {
                        text: this.$route.params.serviceName,
                        href: '#/transactions/' + encodeURIComponent(this.$route.params.serviceName)
                    },
                    {
                        text: this.$t('text.apmPages.transactionsLabel'),
                        active: true
                    }
                ]
            }
        },
        mounted() {
            this.initDate();
        },
        watch: {
            '$route'(to, from) {
                // react to route changes...


                this.initDate();


            }

        },

        methods: {

            ehrambaUserSortFn(x, y, col, rowX, rowY) {
                let _x = rowX.sample.http.request.headers['Ehramba-Final-User'] && rowX.sample.http.request.headers['Ehramba-Final-User'][0] ? rowX.sample.http.request.headers['Ehramba-Final-User'][0] : '';
                let _y = rowY.sample.http.request.headers['Ehramba-Final-User'] && rowY.sample.http.request.headers['Ehramba-Final-User'][0] ? rowY.sample.http.request.headers['Ehramba-Final-User'][0] : '';

                return (_x < _y ? -1 : (_x > _y ? 1 : 0))
            },

            ehrambaIpSortFn(x, y, col, rowX, rowY) {
                let _x = rowX.sample.http.request.headers['X-Real-Ip'] && rowX.sample.http.request.headers['X-Real-Ip'][0] ? Number(rowX.sample.http.request.headers['X-Real-Ip'][0].split(".").map((num) => (`000${num}`).slice(-3) ).join("")) : '';
                let _y = rowY.sample.http.request.headers['X-Real-Ip'] && rowY.sample.http.request.headers['X-Real-Ip'][0] ? Number(rowY.sample.http.request.headers['X-Real-Ip'][0].split(".").map((num) => (`000${num}`).slice(-3) ).join("")) : '';

                console.log(_x);

                return (_x < _y ? -1 : (_x > _y ? 1 : 0))
            },

            updateTimes(){

                this.$router.push({
                    path: "",
                    query:{
                        start: encodeURIComponent(this.startTimestamp),
                        end: encodeURIComponent(this.endTimestamp)
                    }
                });


            },


            routerGoTo(where){

                this.$router.push("/" + where + "/"+ this.$route.params.serviceName + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp));

            },


            getData() {
                this.transactionDurationDataLoaded = false;
                this.requestsPerMinuteDataLoaded = false;


                console.log("cas zacetka: ", this.startTimestamp);
                console.log("cas konca: ", this.endTimestamp);

                axios.get(config.kibana + this.$route.params.serviceName + "/transaction_groups/charts?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + '&transactionType=request' + '&uiFilters=%7B%7D', {headers: {}})
                    .then((res) => {

                        // transaction duration graf
                        console.log("response za transaction duration graf:", res.data);
                        this.transactionDurationSeries[0] = {data: [], name:  this.$t('text.apmPages.average')};
                        this.transactionDurationSeries[1] = {data: [], name: this.$t('text.apmPages.ninetyFifthPercentile')};
                        this.transactionDurationSeries[2] = {data: [], name: this.$t('text.apmPages.ninetyNinthPercentile')};
                        this.transactionDurationSeries[0].data = res.data.apmTimeseries.responseTimes.avg;
                        this.transactionDurationSeries[1].data = res.data.apmTimeseries.responseTimes.p95;
                        this.transactionDurationSeries[2].data = res.data.apmTimeseries.responseTimes.p99;
                        this.transactionDurationDataLoaded = true;
                        console.log("transactionDurationSeries", this.transactionDurationSeries);

                        // requests per minute graf

                        for (var i = 0; i < res.data.apmTimeseries.tpmBuckets.length; i++) {
                            this.requestsPerMinuteSeries[i] = {
                                name: res.data.apmTimeseries.tpmBuckets[i].key,
                                data: res.data.apmTimeseries.tpmBuckets[i].dataPoints,
                            }
                        }
                        this.requestsPerMinuteDataLoaded = true;
                        console.log("requestsPerMinuteSeries", this.requestsPerMinuteSeries);


                    })
                    .catch((error) => {
                        console.log(error);
                    });


                //tabela
                axios.get(config.kibana + this.$route.params.serviceName + "/transaction_groups?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp) + '&transactionType=request' + '&uiFilters=%7B%7D', {headers: {}})
                    .then((res) => {
                        console.log("response za tabelo:", res.data);
                        this.rows = res.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });

            },

            initDate() {

                if (this.$route.query.start == null && this.$route.query.end == null) {
                    this.endTimeDate = new Date();
                    this.startTimeDate = new Date();
                    this.startTimeDate.setDate(this.endTimeDate.getDate() - 1);
                    this.startTimestamp = this.startTimeDate.toISOString();
                    this.endTimestamp = this.endTimeDate.toISOString();

                    this.$router.push({
                        path: "",
                        query:{
                            start: encodeURIComponent(this.startTimestamp),
                            end: encodeURIComponent(this.endTimestamp)
                        }
                    });

                } else {

                    this.startTimestamp = decodeURIComponent(this.$route.query.start);
                    this.endTimestamp = decodeURIComponent(this.$route.query.end);


                }

                this.breadcrumbItems[0].href = "#/apm/" + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.breadcrumbItems[1].href = "#/transactions/" + encodeURIComponent(this.$route.params.serviceName) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp);
                this.getData();
            },


            formatMiliseconds(value) {
                return Math.round(value / 1000) + " " + this.$t('text.apmPages.ms');
            },

            formatTransactionsPerMinute(value) {
                return +parseFloat(value).toFixed(1) + " " + this.$t('text.apmPages.tpm');
            },

            onCellClick(params) {
                console.log(params);
                let transactionGroup = params.formattedRow.name;

                this.$router.push('/transactions/' + this.$route.params.serviceName + '/' + encodeURIComponent(transactionGroup) + "?start=" + encodeURIComponent(this.startTimestamp) + "&end=" + encodeURIComponent(this.endTimestamp));
            }

        },
        beforeCreate: function () {
            document.body.className = 'transactions';
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/Transactions.vue